import { IndividualBaseViewModel } from 'src/app/common/models/IndividualViewModel';
import { IndexedDBHelper } from './indexed-db-helper';
import { IStorageService } from './istorage.service';

export abstract class StorageService<T> implements IStorageService<T> {
  constructor(protected indexedDBHelper: IndexedDBHelper, protected tableName: string) {}
  // private is_indexed_db_enabled = environment.ENABLE_INDEXED_DB;

  async checkTableExists(tableName: string): Promise<boolean> {
    return await this.indexedDBHelper.isTableExist(tableName);
  }

  async createTable(tableName: string): Promise<void> {
    await this.indexedDBHelper.createTable(tableName);
  }

  async saveData(projectId: string, data?: T): Promise<void> {
    await this.indexedDBHelper.saveData(projectId, () => Promise.resolve(data));
  }

  async getById(tableName: string, id: number): Promise<T | null> {
    return await this.indexedDBHelper.getById(tableName, id);
  }

  async deleteTableByName(tableName:string): Promise<void> {
    await this.indexedDBHelper.deleteTable(tableName);
  }
  
  async getAny(): Promise<T | null> {
    throw new Error('Method not implemented.');
  }

  async getAll(tableName: string): Promise<T[] | null> {
    try {
      const data = await this.indexedDBHelper.getAll<T>(tableName);
      if (data && data.length > 0) {
        console.log(`Fetched ${data.length} records from ${this.tableName}.`);
        return data;
      } else {
        console.log(`No data found in ${this.tableName}.`);
        return null;
      }
    } catch (error) {
      console.error(`Error fetching data from ${this.tableName}:`, error);
      return null;
    }
  }

  async updateById(tableName: string, id: number, item: T): Promise<void> {
    await this.indexedDBHelper.updateById(tableName, id, item);
  }

  async deleteById(tableName:string, id:number): Promise<void> {
    await this.indexedDBHelper.deleteById(tableName, id);
  }

  count(filter?: T): Promise<number> {
    throw new Error('Method not implemented.');
  }
  // public abstract getFromAPI(id?: string): Promise<T | null>;
  public abstract getTableName(projectId : string):string

}
